<template>
	<div class="overlay" :class="{show: show}" @click.self="hideOverlay()">
		<div class="wrapper">
			<div class="close" @click="hideOverlay()">
				<close-icon/>
			</div>

			<div class="content">
				<p class="is-size-4" v-for="(text, index) of texts.intro" :key="index" v-html="text">
				</p>

				<a :href="texts.url" target="_blank" class="button-cta">
					<div v-html="texts.button"></div>
					<enveloppe-icon class="enveloppe"/>
				</a>
			</div>

			<div class="share">
				<p>
					Partagez cette carte sur vos réseaux&nbsp;:
				</p>

				<div class="share-items">
					<div class="item facebook tooltip is-tooltip-top" data-tooltip="Facebook" @click="shareFacebook()">
						<facebook-icon/>
					</div>
					<div class="item twitter tooltip is-tooltip-top" data-tooltip="Twitter" @click="shareTwitter()">
						<twitter-icon/>
					</div>
					<div class="item whatsapp tooltip is-tooltip-top" data-tooltip="Whatsapp" @click="shareWhatsapp()">
						<whatsapp-icon/>
					</div>
					<div class="item email tooltip is-tooltip-top" data-tooltip="E-mail" @click="shareEmail()">
						<enveloppe-icon/>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>

import CloseIcon from './icons/fermer.svg'
import EnveloppeIcon from './icons/enveloppe.svg'
import FacebookIcon from './icons/facebook.svg'
import TwitterIcon from './icons/twitter.svg'
import WhatsappIcon from './icons/whatsapp.svg'
import texts from '@texts/cta-overlay.json'

export default {
	name: 'Cta',
	data() {
		return {
			texts: texts,
			show: false,
		}
	},
	components: {
		CloseIcon,
		EnveloppeIcon,
		FacebookIcon,
		TwitterIcon,
		WhatsappIcon,

	},
	methods: {
		showOverlay() {
			this.show = true
		},
		hideOverlay() {
			this.show = false
		},
		shareFacebook() {
			window.open(texts.facebookLink, "_blank")
		},
		shareEmail() {
			location.href = texts.emailLink
		},
		shareTwitter() {
			window.open(texts.twitterLink, "_blank")
		},
		shareWhatsapp() {
			window.open(texts.whatsappLink, "_blank")
		}
	},
}
</script>


<style scoped lang="scss">
.overlay {
	display: none;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, .6);
	z-index:9999999;
	justify-content: center;
	align-items: center;
	&.show {
		display: flex;
	}
}


.wrapper {
	@extend %base-box;

	background-color: #fff;
	max-width: 500px;
	width: 100%;
	height: auto;
	position: relative;
	display: flex;
	flex-direction: column;
	margin: 12px;
/*

	@include from($tablet) {
		max-width: 400px;
	}

	@include from($desktop) {
		max-width: 500px;
	}
*/
	.close {
		position: absolute;
		top: 8px;
		right: 10px;
		width: 12px;
		height: 12px;

		cursor: pointer;

		> * {
			fill: lighten($noir, 40%);
			width: 100%;
		}

	}
}

.share-items {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 20px;

	.item {
		border-radius: 50%;
		margin: 0 10px;
		width: 2.5rem;
		height: 2.5rem;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;

		> * {
			width: 1rem;
			fill: #fff;
		}

		&.facebook {
			background-color: $facebook;
			> * {
				transform: translateX(20%);
			}

			&:hover{
				background-color: darken($facebook, 15%);
			}
		}

		&.twitter {
			background-color: $twitter;
			&:hover{
				background-color: darken($twitter, 15%);
			}
		}

		&.whatsapp {
			background-color: $whatsapp;
			&:hover{
				background-color: darken($whatsapp, 15%);
			}
		}

		&.email {
			background-color: $email;

			path {
				fill: lighten($noir, 10%);
			}

			&:hover{
				background-color: darken($email, 2%);
			}
		}
	}
}

.content {
	width:100%;
	padding: 20px;
	text-align: center;
}

.share {
	background-color: #f1f1f1;
	width: 100%;
	padding: 20px;
	text-align: center;
}

.button-cta {
	@extend %base-btn;
	@extend %font-cta-big;
	background-color: $jaune;
	width: 100%;
	margin: 0;
	padding: 20px 10px;
	height: auto;
	margin-top: 20px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;


	&:hover {
		background-color: darken($jaune, 2%);
	}
}

.enveloppe {
	margin-top: 6px;
	width: 2rem;
	height: 2rem;
	fill: $noir;
}
</style>
